import styled from "@emotion/styled";
import { UiTheme } from "@nykaa/payment-ui/src/@types";


export const ProductsWrapper = styled.div`
  max-height: 310px;
  overflow-y: auto;
`;

export const CartSidebarWrapper = styled.div`
    overflow-y: ${({ isVisible }: UiTheme) => isVisible ? "none" : "auto"};
    position: relative;
    width: 392px;
    background-color: #fff;
    height: 100vh;
    .mob-header-layout, .bottom-sheet-wrap, #discount-info, .footer-layout {
        left: unset;
        width: 392px;
        right:0;
    }
    div[data-test-id="error_overlay"] {
        div:first-of-type {
          div:nth-child(2) {
            left: 30%;
            right: 30%;
          }
        }
      }
`;

export const CouponIframeWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  iframe{
    height: 100%;
    width: 100%;
  }
`;
